/**
 * React Query hooks for Shifts
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { shiftsApi } from '../lib/api';

export const shiftKeys = {
  all: ['shifts'],
  lists: () => [...shiftKeys.all, 'list'],
  list: (filters) => [...shiftKeys.lists(), filters],
};

// Get shifts with filters
export function useShifts(filters = {}) {
  return useQuery({
    queryKey: shiftKeys.list(filters),
    queryFn: () => shiftsApi.getAll(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes - keep in cache even when component unmounts
    networkMode: 'always', // Don't pause queries
  });
}

// Create shift mutation
export function useCreateShift() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: shiftsApi.create,
    onSuccess: () => {
      // Invalidate all shift queries
      queryClient.invalidateQueries({ queryKey: shiftKeys.all });
    },
  });
}

// Update shift mutation
export function useUpdateShift() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => shiftsApi.update(id, data),
    onSuccess: () => {
      // Invalidate all shift queries
      queryClient.invalidateQueries({ queryKey: shiftKeys.all });
    },
  });
}

// Delete shift mutation
export function useDeleteShift() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: shiftsApi.delete,
    onSuccess: () => {
      // Invalidate all shift queries (both lists and individual list queries)
      queryClient.invalidateQueries({ queryKey: shiftKeys.all });
    },
  });
}

